import { createAction } from '@reduxjs/toolkit';

import types from '@constants/action-types';
import { actionRequestFactory, actionResponseFactory } from '@factories';

export const entitiesListRequest = payload =>
  actionRequestFactory(types.ENTITIES_LIST_REQUEST, payload);
export const entitiesListSuccess = (entities, paged) =>
  actionResponseFactory(types.ENTITIES_LIST_SUCCESS, { entities, paged });
export const entitiesListFailure = error =>
  actionResponseFactory(types.ENTITIES_LIST_FAILURE, null, { error });

export const selectEntity = entity => actionResponseFactory(types.SELECT_ENTITY, { entity });
export const removeEntity = entity => actionResponseFactory(types.REMOVE_ENTITY, { entity });
export const removeAllEntities = () => actionResponseFactory(types.REMOVE_ALL_ENTITIES);
export const addSelectedEntities = entities =>
  actionResponseFactory(types.ADD_SELECTED_ENTITIES, { entities });

export const createEntityRequest = payload =>
  actionRequestFactory(types.CREATE_ENTITY_REQUEST, payload);
export const createEntitySuccess = entities =>
  actionResponseFactory(types.CREATE_ENTITY_SUCCESS, entities);
export const createEntityFailure = error =>
  actionResponseFactory(types.CREATE_ENTITY_FAILURE, null, { error });

export const resetModifiedEntity = () => actionRequestFactory(types.RESET_MODIFIED_ENTITY, null);
export const modifyEntityRequest = payload =>
  actionRequestFactory(types.MODIFY_ENTITY_REQUEST, payload);
export const modifyEntitySuccess = entities =>
  actionResponseFactory(types.MODIFY_ENTITY_SUCCESS, entities);
export const modifyEntityFailure = error =>
  actionResponseFactory(types.MODIFY_ENTITY_FAILURE, null, { error });

export const deleteEntityRequest = id => actionRequestFactory(types.DELETE_ENTITY_REQUEST, { id });
export const deleteEntitySuccess = entities =>
  actionResponseFactory(types.DELETE_ENTITY_SUCCESS, entities);
export const deleteEntityFailure = error =>
  actionResponseFactory(types.DELETE_ENTITY_FAILURE, null, { error });

export const getSelectedEntityRequest = createAction('entities/getSelectedRequest');
